export default "__VITE_ASSET__C0h7tK1V__"